export const NEWSLETTER_SUBSCRIBE = 'NEWSLETTER_SUBSCRIBE'
export const NEWSLETTER_UNSUBSCRIBE = 'NEWSLETTER_UNSUBSCRIBE'
export const SET_EMAIL = 'SET_EMAIL'
